document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".video-wrapper").forEach(wrapper => {
      const videoEl = wrapper.querySelector("video");
      const player = videojs(videoEl);

      const playBtn = wrapper.querySelector(".play-button");
      const playIcon = playBtn.querySelector("div:nth-child(1)");
      const pauseIcon = playBtn.querySelector("div:nth-child(2)");
      const desc = wrapper.querySelector("figcaption");
      const imageVideo = wrapper.querySelector(".video-poster");

      playBtn.addEventListener("click", function () {
        console.log('i clicked my button')
        if (player.paused()) {
          player.play();
          playIcon.style.display = "none";
          pauseIcon.style.display = "block";
          imageVideo.style.opacity = "0";
          if (desc) desc.style.display = "none";
          if (desc) desc.style.zIndex = "0";
          } else {
            player.pause();
            playIcon.style.display = "block";
            pauseIcon.style.display = "none";
            imageVideo.style.opacity = "1";
            if (desc) desc.style.display = "flex";
          }
      });

      player.on("ended", function () {
        playIcon.style.display = "block";
        pauseIcon.style.display = "none";
        if (desc) desc.style.display = "flex";
      });
    });
});
